export default "__VITE_ASSET__c5a3fd12__"